/* global grecaptcha */
export default function newsletterSignup () {
  // Process form submissions
  const signupContainers = document.querySelectorAll('.js-newsletter')
  for (let i = 0; i < signupContainers.length; i++) {
    (function (containerEl) {
      const form = containerEl.querySelector('form')
      const emailField = containerEl.querySelector('input[type=email]')
      const button = containerEl.querySelector('button')
      form.addEventListener('submit', function (ev) {
        ev.preventDefault()
        const buttonText = button.innerHTML
        const loadingText = '...'
        if (buttonText === loadingText) return

        grecaptcha.ready(function () {
          grecaptcha.execute(window.RECAPTCHA_SITE_KEY, { action: 'submit' }).then(function (token) {
            const data = 'email=' + encodeURIComponent(emailField.value) + '&token=' + encodeURIComponent(token)
            const url = form.getAttribute('action')
            const request = new XMLHttpRequest()
            request.open('POST', url, true)
            request.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
            request.onload = function () {
              if (request.status === 200) {
                containerEl.classList.add('success')
              } else {
                containerEl.classList.add('error')
                button.innerHTML = buttonText
              }
            }
            request.onerror = function () {
              containerEl.classList.add('error')
            }
            button.innerHTML = loadingText
            request.send(data)
          })
        })
      })
    })(signupContainers[i])
  }
}
